import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { ContentCardModule } from '../../content-card/content-card.module'
import { ElementIsVisibleModule } from '../../element-is-visible/element-is-visible.module'
import { VideoPlayerCardModule } from '../../video-player-card/video-player-card.module'
import { ScrollToElementOnNavigationModule } from '../../_directives/scroll-to-element-on-navigation/scroll-to-element-on-navigation.module'
import { GridContainerComponent } from './grid-container.component'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ElementIsVisibleModule,
    ScrollToElementOnNavigationModule,
    VideoPlayerCardModule,
    ContentCardModule
  ],
  declarations: [GridContainerComponent],
  exports: [GridContainerComponent]
})
export class GridContainerModule {}
